import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M4 8.643v6.714c0 1.578 1.742 2.534 3.074 1.687L11 14.546v.81c0 1.579 1.742 2.535 3.074 1.688l5.275-3.357a2 2 0 0 0 0-3.374l-5.275-3.357C12.742 6.11 11 7.066 11 8.643v.812L7.074 6.956C5.742 6.11 4 7.066 4 8.643"
    }
  )
);
var SvgFastForwardFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FastForwardFilled_default = SvgFastForwardFilled;

export { FastForwardFilled_default as default };
